import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { Plan } from 'src/app/modelo/Plan';
import { AdministracionService } from 'src/app/administracion/administracion.service';
import { DataService } from 'src/app/services/data.service';


import * as moment from 'moment';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ConfirmationService, MessageService, SelectItem, Message } from 'primeng/api';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-admin-planes',
    templateUrl: './admin-planes.component.html',
    styleUrls: ['./admin-planes.component.scss']
})
export class AdminPlanesComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    planList: Plan[] = [];
    plan: Plan = new Plan();
    stateOptions: any[];
    selectedPlan: any[];
    tiposPeriodo: any[];
    tipo: any;
    tiposPlan: any[];
    tipoPlan: any;

    //Variables auxiliares
    valido: boolean = false;
    cols: any[];
    multiSortMeta = [];
    mostrarEditor: boolean = false;
    buttonsActions: any[] = [];

    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    process: boolean = true;

    ui: UIService;
    app: AppComponent;


    constructor(
        public userService: UserService,
        private uiService: UIService,
        private administracionService: AdministracionService,
        private dataService: DataService,
        private appController: AppComponent,


        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService
    ) {
        this.ui = uiService;
        moment.locale('es');
        this.cargarDataConstructor();
        this.stateOptions = [{ label: 'ACTIVO', value: 'ACTIVE' }, { label: 'DESACTIVO', value: 'OFF' }];
    }

    cargarDataConstructor() {
        this.breadcrumbService.setItems([{ label: 'Administración de planes', routerLink: ['admistacrion-planes'] }]);
        this.cargandoDataInit = false;
        this.cols = [
            { field: 'name', header: 'Nombre Plan', visible: true },
            { field: 'tipo', header: 'Tipo plan', visible: true },
            { field: 'precio', header: 'Precio', visible: true },
            { field: 'minimoComprobantes', header: 'Min. Comprobantes', visible: true },
            { field: 'maximoComprobantes', header: 'Max. Comprobantes', visible: true }
        ];
        this.multiSortMeta.push({ field: 'emissionOn', order: -1 });

        this.tiposPeriodo = this.appConfig.properties.listTiposPeriodos;
        this.tipo = (this.tiposPeriodo && this.tiposPeriodo.length) ? this.tiposPeriodo[0] : null;

        this.tiposPlan = this.appConfig.properties.listTiposPlan;

    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData['user'] ? userData['user'] : userData;
            if (this.currentUser) {
                //                let imagen = this.app.sanitize(this.currentUser.image);
                //                this.currentUser.image = typeof (imagen) == 'string' ? imagen : null;
                if ((this.currentUser.initials && this.currentUser.initials != 'RUC NO VALIDO') || this.currentUser.username == 'admin') {
                    this.valido = true;
                    this.cargarDataInit();
                }
            }
        });

    }

    async cargarDataInit() {
        this.planList = await this.administracionService.getPlanesData();
        this.process = false;
    }


    bindPlan(values: Object) {
        Object.assign(this.plan, values);
    }

    guardarInformacion(form: any): void {
        if (this.plan && this.tipoPlan && this.tipo) {
            this.plan.tipoPlan = this.tipoPlan;
            this.plan.tipo = this.tipo.value;
            //Guardar producto en persistencia
            this.administracionService.enviarPlan(this.plan).subscribe(
                async (data) => {
                    this.mostrarEditor = false;
                    this.cargarDataInit(); //Recargar
                    this.ui.mostrarMensaje("success", "Se registró el plan con éxito.");
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    nuevoPlan(): void {
        this.resetVariables();
        this.mostrarEditor = true;
        //        this.cuenta.tipoCuenta = 'AHORRO';
        //        this.nombreCuentaActual = "Nombre de cuenta";
    }


    doRefresh(event) {
        this.cargarDataInit();
        setTimeout(() => {
            event.target.complete();
        }, 500);
    }


    presentarOpcionesActionSheet(event, plan: Plan) {
        this.buttonsActions = [
            {
                text: 'Editar',
                icon: 'pi pi-pencil',
                cssClass: 'p-button-text p-button-info',
                action: 'editar',
                data: plan,
                disabled: false
            },
            {
                text: 'Compartir',
                icon: 'pi pi-share-alt',
                cssClass: 'p-button-text p-button-info',
                action: 'compartir',
                data: plan,
                disabled: false
            },
            {
                text: 'Eliminar',
                icon: 'pi pi-trash',
                cssClass: 'p-button-text p-button-info',
                action: 'eliminar',
                data: plan,
                disabled: false
            },
            {
                text: 'Cancelar',
                icon: 'pi pi-stop-circle',
                cssClass: 'p-button-text p-button-plain',
                action: 'cancelar',
                data: plan,
                disabled: false
            }
        ];
    }

    limpiarMessages = () => {
        this.messageService.clear();
    };
    resetVariables(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        //this.plan = {} as Plan;
        this.tipoPlan = null;
        this.plan = new Plan();
        this.plan.activationTime = new Date();
        this.plan.expirationTime = new Date(this.plan.activationTime + 365);
    }

    async ejecutarAccion(event, accion: string, plan: Plan) {
        this.ui.limpiarMessages();
        switch (accion) {
            case 'compartir':
                this.compartirPlan(plan);
                break;
            case 'eliminar':
                this.confirmarEliminarPlan(plan);
                break;
            case 'editar':
                this.editarPlan(plan);
                break;
        }
    }

    editarPlan(plan: Plan) {
        this.resetVariables();
        this.plan = plan;
        this.plan.activationTime = new Date(this.plan.activationTime);
        this.plan.expirationTime = new Date(this.plan.expirationTime);
        if (this.plan && this.plan.tipoPlan) {
            this.tipoPlan = this.tiposPlan.find((item) => item['value'] == this.plan.tipoPlan)['value'];
        }
        this.mostrarEditor = true;

    }


    compartirPlan(plan: Plan) {
        //Enviar datos de la cuenta
        const title = `Hola estos son mis datos para la transferencia`
        //const summary = `${title}\n${this.currentUser.surname} ${this.currentUser.firstname}\n${cb.name}\n${cb.tipoCuenta} # ${cb.code}\n${this.currentUser.username}\n${this.currentUser.organization.ruc}\n\nConsigue la app FAZil y ten siempre a la mano estos datos`
        //TODO, indicar si la cuenta es personal o de empresa, si es de empresa tomaria datos desde la organización
        const summary = `${title}\n${this.currentUser.surname} ${this.currentUser.firstname}\n${plan.name}\n${plan.status} # ${plan.code}\n${this.currentUser.username}\n${this.currentUser.code}\n\nFue muy FAZil enviarte estos datos, consigue la app FAZil`
        const url = environment.settings.app.contact.url;
        //        this.app.sendShare(summary, title, url);
    }

    async confirmarEliminarPlan(plan: Plan) {
        this.confirmationService.confirm({
            message: '¿Está seguro de realizar esta acción?',
            header: 'Confirmación!',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.eliminarPlan(plan);
            }
        });
    }



    eliminarPlan(plan: Plan) {
        this.process = true;
        //Eliminar en persistencia
        this.administracionService.eliminarPlan(plan.uuid).subscribe(
            async (data) => {
                this.ui.mostrarMensaje("success", "Plan eliminado con éxito.");
                this.cargarDataInit();
            },
            async (err) => {
                this.process = false;
                this.ui.mostrarMensaje(err["type"] ? err["type"] : '¡Ups!',
                    err["message"] ? err["message"] : environment.settings.errorMsgs.error500);
            }
        );
    }

}
